import React from 'react'

export function DrawerTitle({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return <h2 className={'text-headline-1 font-demibold mb-2.5'}>{children}</h2>
}
